//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "CURB65",
  data() {
    return {
      defaultJson: {
        "Age ≥ 65 yr": "年龄 ≥ 65 岁",
        "Confusion": "意识障碍",
        "Blood urea nitrogen > 7mmol/L": "血尿素氮＞7mmol/L",
        "Resp. rate ≥ 30/min": "呼吸频率 ≥ 30次/分",
        "SBP < 90 or DBP ≤ 60 mmHg": "收缩压<90mmHg或舒张压≤60mmHg"
      },
      form: {
        age: "0",
        confusion: "0",
        urea: "0",
        resp: "0",
        bp: "0",
      },
      hasScore: false,
      disabled: false,
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            if (form[key] == "---") {
              flag = false;
            } else {
              form[key] = Number(form[key]);
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false;
        return "--";
      } else {
        let result = form.age + form.confusion + form.urea + form.resp + form.bp;
        self.hasScore = true;
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Pulm/CURB65.vue